import { render, staticRenderFns } from "./MergePerson.vue?vue&type=template&id=e942c02e&scoped=true&"
import script from "./MergePerson.vue?vue&type=script&lang=js&"
export * from "./MergePerson.vue?vue&type=script&lang=js&"
import style0 from "./MergePerson.vue?vue&type=style&index=0&id=e942c02e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e942c02e",
  null
  
)

export default component.exports